import { useState } from "react";
import { Tooltip, Menu, MenuItem } from "@mui/material";

const Breadcrumb = ({ breadcrumpList, setBreadcrumpList, handleClick, maxBreadcrumpsLength = 3 }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleBreadcrumpBack = () => {
    if (breadcrumpList.length > 1) {
      setBreadcrumpList((prev) => {
        const newList = prev.slice(0, -1);
        handleClick(newList[newList.length - 1]);
        return newList;
      });
    }
  };

  const handleBreadcrumpClick = (value, index) => {
    if (index === breadcrumpList.length - 1) return;
    handleClick(value);
    setBreadcrumpList((prev) => prev.slice(0, index + 1));
  };

  const hiddenCount = Math.max(0, breadcrumpList.length - maxBreadcrumpsLength);
  const visibleBreadcrumbs = breadcrumpList.slice(hiddenCount);

  const handleDropdownOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleDropdownClose = () => {
    setAnchorEl(null);
  };

  const handleDropdownClick = (item, index) => {
    handleClick(item);
    setBreadcrumpList(breadcrumpList.slice(0, index + 1));
    handleDropdownClose();
  };

  return (
    <div className="flex items-center gap-2 pe-4 py-1 rounded-md">
      {breadcrumpList.length > 1 && (
        <i className="bi bi-arrow-left mr-2 text-[#1D4469] cursor-pointer" onClick={handleBreadcrumpBack}></i>
      )}

      {/* Dropdown using MUI */}
      {hiddenCount > 0 && (
        <>
          <Tooltip title="More" arrow>
            <span className="cursor-pointer text-[#B4C0C8] text-sm" onClick={handleDropdownOpen}>
              ...
            </span>
          </Tooltip>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleDropdownClose}
            PaperProps={{
              sx: {
                minWidth: 160,
                paddingY: 0.5,
                boxShadow: 3,
                borderRadius: 2,
              },
            }}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          >
            {breadcrumpList.map((item, index) => {
              if (index >= hiddenCount) return null;
              return (
                <MenuItem
                  key={index}
                  onClick={() => handleDropdownClick(item, index)}
                  sx={{
                    fontSize: "13px",
                    color: "#1D4469",
                    paddingY: "6px",
                    paddingX: "12px",
                    "&:hover": {
                      backgroundColor: "#F0F4F8",
                      color: "#0F2D4A",
                    },
                  }}
                >
                  <span className="mr-2">&gt;</span>
                  {item.label}
                </MenuItem>
              );
            })}
          </Menu>

          <span className="mx-1">&gt;</span>
        </>
      )}

      {/* Visible breadcrumb items */}
      {visibleBreadcrumbs.map((value, index) => {
        const actualIndex = index + hiddenCount;
        return (
          <span key={actualIndex} className="flex items-center">
            <span
              className={`cursor-pointer ${
                actualIndex === breadcrumpList.length - 1 ? "text-primary text-[14px]" : "text-[#B4C0C8] text-[12px]"
              }`}
              onClick={() => handleBreadcrumpClick(value, actualIndex)}
            >
              {value.label}
            </span>
            {actualIndex < breadcrumpList.length - 1 && <span className="mx-1">&gt;</span>}
          </span>
        );
      })}
    </div>
  );
};

export default Breadcrumb;
